export default __webpack_public_path__ + "static/media/dot-green.3b47046d.svg";